import React from "react";
import { Box, styled } from "@mui/material";
import { Typography } from "@mui/material";

const PropsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: theme.spacing(5),
  flexWrap: "wrap",
  [theme.breakpoints.down("sm")]: {
    gap: theme.spacing(2),
  },
}));

export const PropBlock = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => {
  return (
    <Box display="flex" alignItems="center" gap={2}>
      <Typography variant="body3" color="textSecondary">
        {label}
      </Typography>
      <Typography variant="body3" noWrap sx={{ minWidth: 0 }}>
        {value}
      </Typography>
    </Box>
  );
};

interface Props {
  items: {
    label: string;
    value: string;
  }[];
}

export const PropsSection = ({ items }: Props) => {
  return (
    <PropsContainer>
      {items.map((item) => (
        <PropBlock key={item.label} label={item.label} value={item.value} />
      ))}
    </PropsContainer>
  );
};
